export default {
  colors: {
    active: 'green.400',
    pending: 'orange.400',
  },
}
